class Drag {

    /** @type {HTMLElement} */
    el = null;
    elX = 0;
    elY = 0;
    elWidth = 0;
    elHeight = 0;
    documentWidth = 0;
    documentHeight = 0;
    canMove = false;
    isDragging = false;
    handleMouseDown = this.__handleMouseDown.bind(this);
    handleMouseMove = this.__handleMouseMove.bind(this);
    handleMouseUp = this.__handleMouseUp.bind(this);
    handleClick = this.__handleClick.bind(this);
    handleMouseEnter = this.__handleMouseEnter.bind(this);
    handleMouseLeave = this.__handleMouseLeave.bind(this);
    handleResize = this.__handleResize.bind(this);
    option = {
        leftEdgeSuctionStyle: {},
        rightEdgeSuctionStyle: {},
        hoverStyle: {}
    };
    suckingEdge = '';

    /**
     * @param {HTMLElement} el 元素
     * @param {Object} option 选项
     * @param {object} option.leftEdgeSuctionStyle 左侧吸边样式
     * @param {object} option.rightEdgeSuctionStyle 右侧吸边样式
     * @param {object} option.hoverStyle 悬停样式
     */
    constructor(el, option = {}) {
        if (!el) {
            throw new Error('element is required');
        }
        this.el = el;
        this.option = { ...this.option, ...option };
        this.__init();
    }

    __init() {
        const rect = this.el.getBoundingClientRect();
        this.elX = rect.left;
        this.elY = rect.top;
        this.elWidth = rect.width;
        this.elHeight = rect.height;
        this.documentWidth = document.documentElement.clientWidth;
        this.documentHeight = document.documentElement.clientHeight;
        this.el.addEventListener('mousedown', this.handleMouseDown);
        this.el.addEventListener('click', this.handleClick);
        this.el.addEventListener('mouseenter', this.handleMouseEnter);
        this.el.addEventListener('mouseleave', this.handleMouseLeave);
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
        window.addEventListener('resize', this.handleResize);
        this.canMove = true;
        this.__handleMouseUp();
    }

    __handleMouseDown() {
        this.canMove = true;
        this.isDragging = false;
    }

    __handleMouseMove(e) {
        this.isDragging = true;
        if (this.canMove) {
            this.elX = e.clientX;
            this.elY = e.clientY;
            this.el.style.left = `${e.clientX - this.elWidth / 2}px`;
            this.el.style.top = `${e.clientY - this.elHeight / 2}px`;
        }
    }

    __handleMouseUp() {
        if (this.canMove === false) return;
        const { el, elX, elY, elWidth, elHeight, documentWidth, documentHeight, option } = this;
        // 边缘检查和吸边处理
        if (elX + elWidth < documentWidth / 2) {
            el.style.left = '0px';
            this.suckingEdge = 'left';
            for (let key in option.leftEdgeSuctionStyle) {
                el.style[key] = option.leftEdgeSuctionStyle[key];
            }
        } else {
            this.suckingEdge = 'right';
            el.style.left = `${documentWidth - elWidth}px`;
            for (let key in option.rightEdgeSuctionStyle) {
                el.style[key] = option.rightEdgeSuctionStyle[key];
            }
        }
        // 始终贴边
        if (elY < 0) {
            el.style.top = '0px';
        } else if (elY + elHeight > documentHeight) {
            el.style.top = `${documentHeight - elHeight}px`;
        }
        this.canMove = false;
    }

    __handleClick(e) {
        if (this.isDragging) {
            e.preventDefault();
            e.stopPropagation();
            this.isDragging = false;
        }
    }

    __handleMouseEnter() {
        for (let key in this.option.hoverStyle) {
            this.el.style[key] = this.option.hoverStyle[key];
        }
    }

    __handleMouseLeave() {
        for (let key in this.option.hoverStyle) {
            this.el.style[key] = this.option[this.suckingEdge + 'EdgeSuctionStyle'][key] || '';
        }
    }

    __handleResize() {
        this.documentWidth = document.documentElement.clientWidth;
        this.documentHeight = document.documentElement.clientHeight;
        this.canMove = true;
        this.__handleMouseUp();
    }

    cancel() {
        this.el.removeEventListener('mousedown', this.handleMouseDown);
        this.el.removeEventListener('click', this.handleClick);
        this.el.removeEventListener('mouseenter', this.handleMouseEnter);
        this.el.removeEventListener('mouseleave', this.handleMouseLeave);
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        window.removeEventListener('resize', this.handleResize);
    }
}

export default Drag;



// WEBPACK FOOTER //
// ./src/utils/drag.js